import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PackagingUnitInfoDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-info-dto';
import { PackagingUnitApiService } from 'src/app/data-transfer/services/packaging-unit-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';
import { PackagingUnitsOverviewComponent } from '../../directory-tree/components/packaging-units-overview/packaging-units-overview.component';

@Component({
  selector: 'app-selection-dialog-packaging-units',
  templateUrl: './selection-dialog-packaging-units.component.html',
  styleUrls: ['./selection-dialog-packaging-units.component.scss']
})
export class SelectionDialogPackagingUnitsComponent {

  @ViewChild('packagingUnitsTable') packagingUnitsTable!: PackagingUnitsOverviewComponent;

  dataSource: PaginationDataSource<PackagingUnitInfoDto>;
  displayedColumns: string[] = [];

  constructor(
    protected dialogRef: MatDialogRef<SelectionDialogPackagingUnitsComponent>,
    private packagingUnitApiService: PackagingUnitApiService,
    @Inject(MAT_DIALOG_DATA) protected data: any
  ) {
    this.dataSource = new PaginationDataSource<PackagingUnitInfoDto>(x => this.packagingUnitApiService.getPackagingUnitsByPage(x));
    if (data) {
      this.displayedColumns = data.displayedColumns;
    }
  }

  importPackagingUnits() {
    this.dialogRef.close({ event: DialogActions.CONFIRM, selectedPackagingUnitIds: this.packagingUnitsTable.selectedPackagingUnitIds });
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
